<template>
  <div style="display: inline">
    <v-btn
      v-if="!hideOpenButton"
      :disabled="disabled"
      :loading="loading"
      :class="['worksansr', openClass]"
      :small="small"
      :x-small="x_small"
      @click="evOnBtnOpenClick"
    >
      <i
        v-if="openLeftIcon"
        :class="[
          openText && 'mr-2',
          small && 'text-twenty',
          'fas',
          openLeftIcon,
        ]"
      ></i>
      {{ openText }}
      <i
        v-if="openRightIcon"
        :class="[
          openText && 'ml-2',
          small && 'text-twenty',
          'fas',
          openRightIcon,
        ]"
      >
      </i>
    </v-btn>

    <b-modal
      :title="modalTitle"
      :header-class="headerClass"
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      centered
      :visible="isVisible"
      @change="evOnModalChange"
    >
      <b-row no-gutters>
        <b-col>
          <h6 class="upper-text text-eighteen color-blackfor">
            {{ messageTitle }}
          </h6>
          <p class="worksansr">{{ messageBody }}</p>
        </b-col>
      </b-row>
      <b-row align-h="between" no-gutters>
        <b-col cols="auto">
          <v-btn
            :disabled="disabled"
            :loading="loading"
            :class="['worksansr btn-modern btn-modern-delete', noClass]"
            @click="evOnBtnNoClick"
          >
            CANCELAR
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn
            :disabled="disabled"
            :loading="loading"
            :class="['worksansr btn-modern btn-modern-save', yesClass]"
            @click="evOnBtnYesClick"
          >
            <i
              v-if="yesLeftIcon"
              :class="['mr-2', 'text-twenty-five', 'fas', yesLeftIcon]"
            />
            {{ yesText }}
            <i
              v-if="yesRightIcon"
              :class="['mr-2', 'text-twenty-five', 'fas', yesRightIcon]"
            />
          </v-btn>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ConfirmationDialog",

  props: {
    value: { type: Boolean, default: false },

    modalTitle: { type: String, default: "CONFIRMAÇÃO" },
    messageTitle: { type: String, required: true },
    messageBody: { type: String, required: true },

    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },

    small: { type: Boolean, default: false },
    x_small: { type: Boolean, default: false },

    headerClass: { type: String, default: "modal-header-red" },

    hideOpenButton: { type: Boolean, default: false },
    openClass: { type: String, required: false },
    openLeftIcon: { type: String, default: "" },
    openRightIcon: { type: String, default: "" },
    openText: { type: String, required: false },

    noClass: { type: String, default: "btn-cancel" },
    noLeftIcon: { type: String, default: "" },
    noRightIcon: { type: String, default: "" },
    noText: { type: String, default: "CANCELAR" },

    yesClass: { type: String, default: "btn-save" },
    yesLeftIcon: { type: String, default: "" },
    yesRightIcon: { type: String, default: "" },
    yesText: { type: String, default: "CONFIRMAR" },
  },

  data() {
    return {
      isVisible: false,
    };
  },

  watch: {
    value(newValue) {
      this.isVisible = newValue;
    },
  },

  methods: {
    async evOnModalChange(value) {
      this.isVisible = value;
      this.$emit("input", value);
    },

    async evOnBtnOpenClick() {
      this.isVisible = true;
      this.$emit("input", true);
    },

    async evOnBtnNoClick() {
      this.isVisible = false;
      this.$emit("input", false);
      this.$emit("no");
    },

    async evOnBtnYesClick() {
      this.isVisible = false;
      this.$emit("input", false);
      this.$emit("yes");
    },
  },
};
</script>
 